import React, { useEffect, useState } from 'react'
import { getNews } from '../Service/Api';
import { Link } from 'react-router-dom'   
const HomeNews = () => {
   const [data, setData] = useState([]); // State for gallery data
   const [loading, setLoading] = useState(true); // State for loading indicator 
 
   useEffect(() => {
     const fetchData = async () => {
       try {
         const topperData = await getNews();
         setData(topperData);
       } catch (error) {
         console.error("Error fetching gallery data:", error);
         // Handle error (e.g., show error message)
       } finally {
         setLoading(false); // Set loading to false after data fetching is complete
       }
     };
     fetchData();
   }, []);
   
  return (
     <> 
     <div className="newssec-area">
     <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up" onMouseOut={(event) => event.currentTarget.start()}>
     {data.length>0 ? data.map((item, index) => (
     <div className="newbox" key={index}>
           <div className="newssec-area-box-con">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              <h6>{item.attachments && item.attachments.length > 0 && (<Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`} className="link" target="_blank"> <p><i className="bi bi-calendar-event"></i>{item.fromDate}</p> <span> Attachment </span></Link>)} </h6>
           </div>
        </div>
        )):(
         <div className="newbox">
         <div className="newssec-area-box-con">
            <h2>News Title</h2>
            <p>Stay Tuned For More Updates</p>
            <h6> <p><i className="bi bi-calendar-event"></i>DD.MM.YYYY</p>   </h6>
         </div>
      </div>
        )}
     
     </marquee>
  </div>
     </>
  )
}

export default HomeNews